import { useNavigate } from "react-router-dom";
import Routes from "router/routes";

const TemplatesPage = () => {
  const navigate = useNavigate();
  const SOCIAL_MEDIA_TEMPLATES = [
    {
      title: "Whatsapp Templates",
      description: "Get templates for whatsapp",
      onClick: () => {
        navigate(Routes.SOCIAL_TEMPLATE("whatsapp"));
      },
      image: "/assets/images/whatsapp.svg",
    },
    {
      title: "Instagram Templates",
      description: "Get templates for Instagram",
      image: "/assets/images/instagram.svg",
      onClick: () => {
        navigate(Routes.SOCIAL_TEMPLATE("instagram"));
      },
    },
    {
      title: "X Templates",
      description: "Get templates for X",
      image: "/assets/images/twitter.svg",
      onClick: () => {
        navigate(Routes.SOCIAL_TEMPLATE("x"));
      },
    },
  ];

  return (
    <div className="mx-2 mt-[50px] min-h-[calc(100vh-280px)] max-w-[870px] lg:mx-auto lg:mt-[64px]">
      <div className="flex flex-col gap-2">
        <p className="font-inter text-[20px] font-semibold leading-[100%] tracking-[-1.5%] text-strong-950 lg:text-[32px] lg:leading-[40px] lg:tracking-[-1.5%]">
          Social media sharing templates
        </p>
        <p className="font-inter text-[16px] font-normal leading-[24px] tracking-[-1.5%] text-neutral-700 lg:text-[20px] lg:leading-[28px] lg:tracking-[0em]">
          Get ideas to share your campaign on social media.
        </p>
      </div>
      <div className="mt-[37px] lg:mt-[70px]">
        <div className="flex flex-col gap-4 lg:flex-row">
          {SOCIAL_MEDIA_TEMPLATES.map((template) => (
            <div
              onClick={template.onClick}
              key={template.title}
              className="w-full cursor-pointer lg:w-[33%]"
            >
              <img
                src={template.image}
                alt={template.title}
                className="w-full"
              />
              <div className="mt-5 flex flex-col gap-2 lg:gap-3">
                <p className="font-inter text-[20px] font-semibold leading-[100%] tracking-[-1.5%] text-strong-950">
                  {template.title}
                </p>
                <p className="font-inter text-[16px] font-normal leading-[22px] tracking-[-1.5%] text-neutral-700 lg:mt-3">
                  {template.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TemplatesPage;
